import { Controller } from "@hotwired/stimulus";
import { Map, Marker, LngLat, LngLatBounds } from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import { createMap } from "../../../../scripts/mapbox";
import { addBoundingBox, forceMapToRedrawWhenInitiallyHidden } from "../../../../Components/Map/MapComponentShared";
import { IGpsCoordinates } from "../../../../scripts/_generated/IGpsCoordinates";
import { BoundingBoxConstants } from "../../../../scripts/_generated/BoundingBoxConstants";
import { IBoundingBox } from "../../../../scripts/_generated/IBoundingBox";

export default class AddNewDestinationMapController extends Controller {
    static targets = ["container"];

    readonly containerTarget!: HTMLElement;

    map!: Map;
    destinationMarker!: Marker;

    connect() {
        this.map = createMap(this.containerTarget, new LngLatBounds(
            [BoundingBoxConstants.worldBoundWest, BoundingBoxConstants.worldBoundSouth],
            [BoundingBoxConstants.worldBoundEast, BoundingBoxConstants.worldBoundNorth]
        ));

        forceMapToRedrawWhenInitiallyHidden(this.containerTarget, this.map);
    }

    setDestinationMarkerAndBoundingBox(coordinates: IGpsCoordinates, boundingBox: IBoundingBox) {
        addBoundingBox(this.map, boundingBox);

        var coordinatesAsLngLat = new LngLat(coordinates.longitude, coordinates.latitude);
        if (!this.destinationMarker) {
            this.destinationMarker = new Marker({
                color: "#31bb11",
                draggable: false,
                anchor: 'bottom',
            });
            this.destinationMarker.setLngLat(coordinatesAsLngLat);
            this.destinationMarker.addTo(this.map);
        } else {
            this.destinationMarker.setLngLat(coordinatesAsLngLat);
        }

        this.map.fitBounds(
            [boundingBox.southEast.longitude,
            boundingBox.southEast.latitude,
            boundingBox.northWest.longitude,
            boundingBox.northWest.latitude],
            {
                animate: true,
                padding: 20
            }
        );
    }

    zoomIn() {
        this.map.zoomIn();
    }

    zoomOut() {
        this.map.zoomOut();
    }
}
